module.exports = __webpack_public_path__ + "img/Hero_YTbg.48b81d08.jpg";